<template>
    <div class="speed-data-section">
        <!-- 模块标题 -->
        <h3>3.5、速度与转速对比分析</h3>

        <!-- ECharts 柱状图容器 -->
        <div>

        </div>


        <el-table :data="tableData" border :cell-style="cellStyle" :header-cell-style="headerCellStyle"
            style="width: max-content; min-width: 100%;">
            <!-- 转速列（首列） -->
            <el-table-column label="转速" prop="speed" width="60" align="center" />
            <!-- 速度区间列（横向表头） -->
            <el-table-column v-for="(speed, idx) in speedHeaders" :key="idx" :label="speed" align="center" width="50">
                <template slot-scope="scope">
                    {{ scope.row[`speed${speed.replace(/[≤>]/g, '')}`] || '0.00' }}
                </template>
            </el-table-column>
            <!-- 累计列 -->
            <el-table-column label="累计" prop="total" width="60" align="center" />
        </el-table>

        <div class="table-caption">数据表4</div>

        <!-- 说明文本 -->

    </div>
</template>

<script>

export default {
    name: "barchart",

    data() {
        return {
            // 速度区间表头（横向列）
            speedHeaders: ['0', '≤10', '≤20', '≤30', '≤40', '≤50', '≤60', '≤70', '≤80', '≤90', '≤100', '≤110', '≤120', '>120'],
            // 表格数据：转速为行，速度区间为列
            tableData: [
                { speed: '>2400', total: '0.00' },
                { speed: '≤2400', total: '0.00' },
                { speed: '≤2200', speed50: '0.02', total: '0.02' },
                { speed: '≤2000', speed30: '0.01', speed40: '0.02', speed60: '0.05', total: '0.08' },
                { speed: '≤1900', speed20: '0.03', speed30: '0.04', speed40: '0.05', speed50: '0.02', speed70: '0.05', total: '0.18' },
                { speed: '≤1800', speed20: '0.05', speed30: '0.07', speed40: '0.20', speed50: '0.01', speed60: '0.11', speed70: '0.04', total: '0.48' },
                { speed: '≤1700', speed0: '0.01', speed10: '0.03', speed20: '0.14', speed30: '0.12', speed40: '0.35', speed50: '0.01', speed60: '0.62', speed70: '0.01', speed80: '0.10', speed90: '0.35', total: '1.74' },
                { speed: '≤1600', speed0: '0.13', speed10: '0.06', speed20: '0.28', speed30: '0.05', speed40: '0.59', speed50: '0.00', speed60: '0.92', speed70: '0.09', speed80: '3.53', total: '5.75' },
                { speed: '≤1500', speed0: '0.15', speed10: '0.11', speed20: '0.24', speed30: '0.16', speed40: '0.55', speed50: '0.97', speed60: '0.49', speed70: '0.00', speed80: '1.44', speed90: '0.00', speed100: '2.69', total: '6.89' },
                { speed: '≤1400', speed0: '0.04', speed10: '0.24', speed20: '0.38', speed30: '0.69', speed40: '0.15', speed50: '1.78', speed60: '0.02', speed70: '1.08', speed80: '0.02', speed90: '0.41', speed100: '0.06', total: '4.86' },
                { speed: '≤1300', speed0: '0.10', speed10: '0.34', speed20: '0.40', speed30: '0.78', speed40: '0.12', speed50: '2.09', speed60: '0.23', speed70: '1.31', speed80: '0.98', speed90: '0.47', total: '6.82' },
                { speed: '≤1200', speed0: '0.15', speed10: '0.39', speed20: '0.48', speed30: '1.04', speed40: '1.51', speed50: '0.49', speed60: '1.72', speed70: '0.03', speed80: '0.57', total: '6.38' },
                { speed: '≤1100', speed0: '0.02', speed10: '0.40', speed20: '0.47', speed30: '1.14', speed40: '1.46', speed50: '0.12', speed60: '1.00', speed70: '0.19', speed80: '0.04', total: '4.85' },
                { speed: '≤1000', speed0: '0.03', speed10: '0.44', speed20: '0.88', speed30: '0.58', speed40: '0.88', speed50: '0.47', speed60: '0.05', speed70: '0.12', total: '3.45' },
                { speed: '≤900', speed0: '0.07', speed10: '0.62', speed20: '0.82', speed30: '0.30', speed40: '0.16', speed50: '0.14', speed60: '0.04', speed70: '0.01', speed80: '0.00', total: '2.17' },
                { speed: '≤800', speed0: '3.02', speed10: '1.57', speed20: '0.56', speed30: '0.36', speed40: '0.12', speed50: '0.05', speed60: '0.02', speed70: '0.00', speed80: '0.03', total: '5.70' },
                { speed: '≤750', speed0: '0.63', speed10: '6.79', speed20: '1.63', speed30: '1.15', speed40: '0.59', speed50: '0.35', speed60: '0.21', speed70: '0.11', speed80: '0.03', speed90: '0.01', total: '11.50' },
                { speed: '≤680', speed0: '35.58', speed10: '1.21', speed20: '0.33', speed30: '0.27', speed40: '0.21', speed50: '0.10', speed60: '0.04', speed70: '0.02', total: '35.77' },
                { speed: '≤500', speed0: '0.21', speed10: '0.01', total: '0.21' }
            ]

        };
    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {
        // 表头样式：转速列浅灰，速度区间列浅蓝
        headerCellStyle({ columnIndex }) {
            if (columnIndex === 0) return { 'background-color': '#f5f7fa' };
            return { 'background-color': '#e6f7ff' };
        },
        // 单元格样式：按数值着色，关键数值高亮
        cellStyle({ row, columnIndex }) {
            const speed = row.speed;
            const speedColKey = this.speedHeaders[columnIndex - 1]?.replace(/[≤>]/g, '');
            const cellValue = row[`speed${speedColKey}`] || '0.00';
            const value = Number(cellValue);

            // 高亮关键数值（如≤680行的35.58）
            if (speed === '≤680' && columnIndex === 1 && value > 30) {
                return { 'background-color': '#fde2e2', 'font-weight': 'bold' };
            }
            // 数值梯度背景色
            if (value >= 10) return { 'background-color': '#fde2e2' };
            if (value >= 5) return { 'background-color': '#ffe6e6' };
            if (value >= 2) return { 'background-color': '#e6f7ff' };
            if (value > 0) return { 'background-color': '#f0f9eb' };
            return {};
        }

    }
};
</script>
<style scoped></style>